"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgKeyTypeEnum = exports.SPOrganization = exports.ChatAccessEnum = void 0;
const firebase_1 = require("../bindings/firebase");
var ChatAccessEnum;
(function (ChatAccessEnum) {
    ChatAccessEnum[ChatAccessEnum["DISABLED"] = -1] = "DISABLED";
    ChatAccessEnum[ChatAccessEnum["ALL"] = 0] = "ALL";
    ChatAccessEnum[ChatAccessEnum["SAFE_SPLIT"] = 1] = "SAFE_SPLIT";
})(ChatAccessEnum = exports.ChatAccessEnum || (exports.ChatAccessEnum = {}));
class SPOrganization {
    constructor(org) {
        this.custom_fields = [];
        this.address = org.address;
        this.visit_address = org.visit_address;
        this.practice_day = org.practice_day;
        this.altered = org.altered;
        this.bank_account = org.bank_account;
        this.status = org.status;
        if (org.comment) {
            this.comment = org.comment;
        }
        this.contact = org.contact;
        this.created = org.created;
        this.members = org.members;
        this.org_id = org.org_id;
        this.org_name = org.org_name;
        this.org_number = org.org_number;
        if (org.region_id) {
            this.region_id = org.region_id;
        }
        if (org.pictures) {
            this.pictures = org.pictures;
        }
        if (org.sentral_ref) {
            this.sentral_ref = org.sentral_ref;
        }
        this.settings = org.settings;
        if (org.web_page) {
            this.web_page = org.web_page;
        }
        if (org.founding_date) {
            this.founding_date = org.founding_date;
        }
        if (org.filestorage) {
            this.filestorage = org.filestorage;
        }
        if (org.custom_fields) {
            this.custom_fields = org.custom_fields;
        }
        if (org.org_keys) {
            this.org_keys = org.org_keys;
        }
    }
    static new(data) {
        const orgData = {
            address: {
                address: '',
                city: '',
                post_code: '',
            },
            visit_address: {
                address: '',
                city: '',
                post_code: '',
                place: '',
            },
            practice_day: {
                day: undefined,
                start_time: undefined,
                end_time: undefined,
            },
            altered: firebase_1.firebase.firestore.Timestamp.now(),
            // bank_account: '',
            contact: { invoice_email: '' },
            created: firebase_1.firebase.firestore.Timestamp.now(),
            members: 0,
            org_id: '',
            org_name: '',
            // org_number: '',
            settings: {
                departments: true,
                member_children: true,
                chat_access: ChatAccessEnum.ALL,
            },
            ...data,
        };
        return new this(orgData);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            throw new Error('Organization snapshot does not exist');
        }
        const org = this.new(snapshot.data());
        org._querySnap = snapshot;
        org._ref = snapshot.ref;
        org._parentId = snapshot.id;
        return org;
    }
    static fromQuerySnapshot(snapshot) {
        const orgs = [];
        if (snapshot.empty) {
            return orgs;
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const d of snapshot.docs) {
            const org = this.fromQueryDocumentSnapshot(d);
            if (org) {
                orgs.push(org);
            }
        }
        return orgs;
    }
    static async fromFirebase(orgid) {
        const snapshot = await (0, firebase_1.fs)()
            .collection('organizations')
            .doc(orgid)
            .get();
        return this.fromQueryDocumentSnapshot(snapshot);
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error(`Somehow parentid does not exist! ${this.org_name}`);
        }
        return this._parentId;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error(`Somehow querysnap does not exist! ${this.org_name}`);
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error(`Somehow ref does not exist! ${this.org_name}`);
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error(`Somehow id does not exist! ${this.org_name}`);
        }
        return qs.id;
    }
}
exports.SPOrganization = SPOrganization;
var OrgKeyTypeEnum;
(function (OrgKeyTypeEnum) {
    OrgKeyTypeEnum[OrgKeyTypeEnum["DEFAULT"] = 0] = "DEFAULT";
    OrgKeyTypeEnum[OrgKeyTypeEnum["ENROLLMENT"] = 1] = "ENROLLMENT";
})(OrgKeyTypeEnum = exports.OrgKeyTypeEnum || (exports.OrgKeyTypeEnum = {}));
//# sourceMappingURL=organization.js.map